import { render } from "./que-points.vue?vue&type=template&id=4e2ebc7c"
import script from "./que-points.vue?vue&type=script&lang=js"
export * from "./que-points.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__